// extracted by mini-css-extract-plugin
export default {"links":"social-media-links-module--links--RFcxX"};